import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { ClownNose } from "./ClownNose";
import { colorMap } from "@/data/articulos";

export const ArticuloCard = ({ a, index = 0 }) => {
  const c = colorMap[a.color];
  return (
    <Link to={`/blog/${a.slug}`} data-testid={`articulo-card-${a.slug}`} className={`group relative flex flex-col rounded-[2rem] p-8 lg:p-10 overflow-hidden ${c.bg} ${c.fg} hover:-translate-y-2 transition duration-300 shadow-lg min-h-[380px]`}>
      <div className="absolute -right-10 -top-10 w-40 h-40 rounded-full bg-white/10" />
      <div className="flex items-center justify-between mb-8">
        <span className="text-[11px] tracking-[0.25em] font-bold uppercase opacity-90">{a.categoria}</span>
        <ClownNose size={22} className="border-2 border-white/70 group-hover:scale-125 transition" />
      </div>
      <span className="font-script text-5xl opacity-40 leading-none">0{index + 1}</span>
      <h3 className="text-2xl lg:text-3xl leading-tight mt-2 mb-4 font-display">{a.titulo}</h3>
      <p className="opacity-85 text-sm lg:text-base leading-relaxed flex-1">{a.resumen}</p>
      <div className="mt-8 flex items-center justify-between text-sm font-semibold">
        <span className="inline-flex items-center gap-1.5 opacity-80"><Clock size={14} /> {a.lectura}</span>
        <span className="inline-flex items-center gap-2">Leer <ArrowRight size={16} className="group-hover:translate-x-1 transition" /></span>
      </div>
    </Link>
  );
};
